<template>
  <div v-loading="loading">
    <div v-if="!loading && form.formId > 0">
      <!--渲染表单-->
      <form-render class="process-form" ref="form" :forms="forms" v-model="formData" :data="value"/>
    </div>
    <div v-if="false">
      <el-divider>审批流程</el-divider>
      <!--渲染流程执行过程-->
      <el-alert type="warning" description="开源版后台只是为了演示流程设计功能，后台无法处理流程发起的后续步骤，如需要完整的工作流功能请移步 👉 pro 版本"></el-alert>
      <el-link href="http://106.13.16.28:83">访问pro👉 </el-link>
      <el-timeline :reverse="false">
        <!--<el-timeline-item v-for="(activity, index) in activities" :key="index">

          </el-timeline-item>-->
      </el-timeline>
    </div>
  </div>
</template>

<script>
import FormRender from '@/views/a-oa/approve/common/form/FormRender'
// import FormDesignRender from '@/views/a-oa/approve/admin/layout/form/FormDesignRender'
import { getFormDetail, getProcess } from '@/api/oa_approve'

export default {
  name: 'InitiateProcess',
  components: { FormRender },
  props: {
    code: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      formData: {},
      value: {},
      form: {
        formId: '',
        formName: '',
        logo: {},
        formItems: [],
        process: {},
        remark: ''
      }
    }
  },
  mounted () {
    if (this.type === 'template') {
      this.loadFormInfo(this.code)
    } else if (this.type === 'data') {
      this.loadResultFormInfo(this.code)
    }
  },
  computed: {
    forms () {
      return this.$store.state.oaApprove.design.formItems
    }
  },
  methods: {
    loadFormInfo (formId) {
      console.log('创建的时候用的')
      this.loading = true
      getFormDetail(formId).then(rsp => {
        this.loading = false
        console.log(rsp.data.entries)
        const form = rsp.data.entries[0]
        const editFormItem = JSON.parse(form.form_items).map(item => {
          item.props.multipleEdited = true
          return item
        })
        form.form_items = JSON.stringify(editFormItem)
        form.formId = form.id
        form.formName = form.template_name
        form.groupId = form.group_id
        form.group_id = undefined
        form.settings = JSON.parse(form.settings)
        form.formItems = JSON.parse(form.form_items)
        form.process = JSON.parse(form.process)
        // 构建表单及校验规则
        this.$store.state.oaApprove.design = form
        this.form = form
      }).catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    loadResultFormInfo (formId) {
      console.log('加载的时候用的')
      getProcess({ id: formId })
        .then(({ data }) => {
          const record = data.entries[0]
          this.value = JSON.parse(record.approval_content).reduce((acc, item) => {
            if (item.name === 'ImageUpload' && item.valueType === 'Array') {
              acc[item.id] = item.value.map(item2 => {
                const name = item2.substring(item2.lastIndexOf('/') + 1)
                const newItem = { name: name, url: item2 }
                return newItem
              })
            } else {
              acc[item.id] = item.value
            }
            return acc
          }, {})
          const form = record.template
          // form.form_items = record.approval_content
          form.formId = form.id
          form.formName = form.template_name
          form.groupId = form.group_id
          form.group_id = undefined
          form.settings = JSON.parse(form.settings)
          form.formItems = JSON.parse(form.form_items).map(item => {
            item['value'] = this.value[item.id]
            return item
          })
          form.process = JSON.parse(form.process)
          // this.value = JSON.parse(record.approval_content).reduce((acc, item) => {
          //   if (item.name === 'ImageUpload' && item.valueType === 'Array') {
          //     acc[item.id] = item.value.map(item2 => {
          //       const name = item2.substring(item2.lastIndexOf('/') + 1)
          //       const newItem = { name: name, url: item2 }
          //       return newItem
          //     })
          //   } else {
          //     acc[item.id] = item.value
          //   }
          //   return acc
          // }, {})
          console.log('========>>>', form)
          this.form = form
          // 构建表单及校验规则
          this.$store.state.oaApprove.design = form
        })
    },
    validate (call) {
      this.$refs.form.validate(call)
    },
    getFormData () {
      return this.formData
    },
    getForm () {
      return this.form
    }
  }
}
</script>

<style lang="less" scoped>
.process-form {
  /deep/ .el-form-item__label {
    padding: 0 0;
  }
}
</style>
